"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _auth = require("@/utils/auth");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var service = _axios.default.create({
  baseURL: process.env.VUE_APP_MAPI_BASE_URL,
  timeout: 120000
});

// request interceptor
service.interceptors.request.use(function (config) {
  var accessToken = (0, _auth.getAccessToken)() || sessionStorage.getItem('accessToken') || localStorage.getItem('accessToken');
  if (accessToken) {
    config.headers['X-Token'] = accessToken;
  }
  if (/get/i.test(config.method)) {
    config.params = config.params || {};
    config.params.temp = Date.parse(new Date()) / 1000;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  // 如果是 blob 响应类型，检查是否为错误响应（后端可能返回 JSON 错误而非文件二进制）
  if (response.config.responseType === 'blob') {
    var blob = response.data;
    // 如果 blob 类型是 JSON，说明后端返回了错误信息而非文件
    if (blob.type && blob.type.includes('application/json')) {
      return blob.text().then(function (text) {
        var errData = JSON.parse(text);
        (0, _elementUi.Message)({
          message: errData.message || '下载失败',
          type: 'error',
          duration: 5 * 1000
        });
        return Promise.reject(errData);
      });
    }
    return blob;
  }
  var res = response.data;
  if (res.code === 401) {
    _elementUi.Message.error('无效的会话，或者登录已过期，请重新登录。');
    if (window.location.pathname !== '/login') location.href = '/login';
  } else if (res.code === 403) {
    _elementUi.Message.error('没有权限访问。');
  }
  // 新系统成功 code 为 0，老系统成功 code 为 200，需兼容两者
  if (res.code !== 0 && res.code !== 200 && res.code !== 401) {
    (0, _elementUi.Message)({
      message: res.message || 'Error',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(res);
  } else {
    if (res.data === null || typeof res.data === 'undefined') {
      return res.message;
    }
    return res.data;
  }
}, function (error) {
  (0, _elementUi.Message)({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
var _default = exports.default = service;